// Controle de acesso padrão gravado ao criar a empresa.
//
// As chaves abaixo do Dashboard (dash e card) espelham o SUB_SCREENS de
// admin/src/util/accessControl.js — caminho completo "Dashboard/<dash>/<card>".
// No admin, dash/card sem valor herdam o pai; aqui eles são gravados marcados
// para a tabela da empresa nova já nascer explícita.

// Perfis que nascem com acesso (Estoquista e Outros começam sem nada).
const PROFILES = ["Gerente", "Vendedor(a)", "Administrador"];

const SCREENS = [
  "Home",
  "Acervo",
  "Mobile",
  "Extrato",
  "Pedidos",
  "Campanha",
  "Cashback",
  "Produtos",
  "Tutorial",
  "Dashboard",
  "Cupom Desc.",
  "Vendedor(a)",
  "Importações",
  "Configurações",
  "Clientes",
  "Mooda AI",
  "MoodaChat",
  "Provador Virtual",
  "Integrações",
];

// Dashboard -> dash -> cards.
export const DASHBOARD_TREE = {
  Vendas: ["Vendas", "Vend. Estratégica", "Pagamentos", "Mapa de Vendas"],
  Clientes: ["Cliente", "Pedidos Clientes"],
  Produtos: [
    "Produto",
    "Produto com Venda",
    "Avise-me quando chegar",
    "Grade Incompleta",
    "Estoque",
  ],
};

export const DASHBOARD_KEYS = Object.entries(DASHBOARD_TREE).flatMap(
  ([dash, cards]) => [
    `Dashboard/${dash}`,
    ...cards.map((card) => `Dashboard/${dash}/${card}`),
  ],
);

export function defaultAccessControl() {
  const allowed = () =>
    Object.fromEntries(PROFILES.map((profile) => [profile, true]));
  return Object.fromEntries(
    [...SCREENS, ...DASHBOARD_KEYS].map((key) => [key, allowed()]),
  );
}
